module.exports = __webpack_public_path__ + "static/media/firstOktoberfest.9a19f0cd.jpg";